import { List, Map } from 'immutable';

const prefix = ['app', 'analysis', 'global'];

export const selectedMarketAreaSelector = state =>
  state.getIn([...prefix, 'selectedMarketAreaRecord']);

export const getRollCorrections = state =>
  state
    .getIn(
      [...prefix, 'rollCorrections', 'data'],
      Map({ data: List() }),
    )
    .toJS();
